import { ApiService } from 'src/app/api.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchComponent } from '../search/search.component';
import { MenuMobileComponent } from './../menu-mobile/menu-mobile.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  categories: any;
  subCategories: any;
  subSubCategorie: any;
  subcategorieReports: any[]= []
  activeMenu: 'products' | 'atendimento' | 'sobre' | null = null;
  activeCategoryId: number | null = null;
  activeSubcategoryId: number | null = null;
  reportsOpen = false;
  isDarkMode = true;
  constructor(
    private matDialog: MatDialog,
    private apiService: ApiService,
    private router: Router,
    private elementRef: ElementRef<HTMLElement>
  ) { }

  ngOnInit(): void {
    this.loadCategories();

  }

 loadCategories(){
    this.apiService.loadCategories().then((result => {
      this.categories = result
    this.categories.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
      return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
    });
  }))
  }


  showSubcategory(show: boolean, category: any) {
    this.subSubCategorie = [];
  if (show) {
    this.activeCategoryId = category?.id ?? null;
    this.activeSubcategoryId = null;
    this.subCategories = category.categorias;
    this.subCategories.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
      return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
    });
  } else {
    this.subCategories = [];
    this.activeCategoryId = null;
  }
}
showReports(show: boolean){
  if(show){
    this.reportsOpen = true;
    this.activeMenu = 'sobre';
    this.subcategorieReports = [
      {nome: 'Metalúrgica 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatorio+Transparencia+Metal.pdf'},
      {nome: 'Metalúrgica 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 02/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatorio_Transparencia_082026_Metalurgica.pdf'},


      {nome: 'Plástico 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/relatorio+Transparecncia+Plasticos.pdf'},
      {nome: 'Plástico 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Plasticos.pdf'},
      {nome: 'Plástico 02/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatorio_Transparencia_082026_Plasticos.pdf'}


      
    ]
  } else{
    this.subcategorieReports = [];
    this.reportsOpen = false;
  }
}
hideReport(){
  this.subcategorieReports = [];
  this.reportsOpen = false;
}
  async checkHasProducts(subcategorias: any){
    if(!subcategorias) return;

    const categoryHasProducts = await Promise.all(subcategorias.map(async (categoria: any) => {
      let products = await this.apiService.getCategoriesWithProductsFiltered(categoria.id);
      if(products.length > 0){
        categoria.hasProducts = true;
        return categoria;
      } else {
        categoria.hasProducts = false;
        return null;
      }
    }));

    return categoryHasProducts.filter(categoria => categoria !== null);
  }

  async showSubSubcategory(show: boolean, subCategory: any){
    if (show && subCategory && subCategory.subcategorias) {
      this.activeSubcategoryId = subCategory?.id ?? null;
      this.subSubCategorie = await this.checkHasProducts(subCategory.subcategorias);
      this.subSubCategorie.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
        return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
      });
    } else {
      this.subSubCategorie = [];
      this.activeSubcategoryId = null;
    }
  }
  hideCategory(){
    this.subCategories = [];
    this.subSubCategorie = [];
    this.activeCategoryId = null;
    this.activeSubcategoryId = null;
  }

  setActiveMenu(menu: 'products' | 'atendimento' | 'sobre') {
    this.activeMenu = menu;
  }

  private getFocusable(selector: string): HTMLElement[] {
    return Array.from(
      this.elementRef.nativeElement.querySelectorAll<HTMLElement>(selector)
    ).filter((element) => element.offsetParent !== null);
  }

  private focusElement(element?: HTMLElement | null) {
    element?.focus({ preventScroll: true });
  }

  private focusByDelta(selector: string, current: HTMLElement, delta: number) {
    const items = this.getFocusable(selector);
    if (!items.length) {
      return;
    }

    const currentIndex = items.indexOf(current);
    const nextIndex = currentIndex === -1
      ? 0
      : (currentIndex + delta + items.length) % items.length;

    this.focusElement(items[nextIndex]);
  }

  private focusFirst(selector: string) {
    const items = this.getFocusable(selector);
    this.focusElement(items[0]);
  }

  private focusTopNav(current: HTMLElement, delta: number) {
    this.focusByDelta('[data-top-nav-item]', current, delta);
  }

  private getTriggerAnchor(menu: 'products' | 'atendimento' | 'sobre') {
    return this.elementRef.nativeElement.querySelector<HTMLElement>(
      `[data-menu-trigger="${menu}"]`
    );
  }

  private openMenuByTrigger(menu: 'products' | 'atendimento' | 'sobre') {
    this.activeMenu = menu;

    if (menu === 'products' || menu === 'atendimento') {
      this.hideReport();
    }

    if (menu === 'products' || menu === 'atendimento' || menu === 'sobre') {
      this.hideCategory();
    }

    if (menu === 'sobre') {
      this.showReports(false);
    }
  }

  private focusFirstMenuItem(menu: 'products' | 'atendimento' | 'sobre') {
    if (menu === 'products') {
      this.focusFirst('[data-products-category]');
      return;
    }

    if (menu === 'atendimento') {
      this.focusFirst('[data-atendimento-item]');
      return;
    }

    if (menu === 'sobre') {
      this.focusFirst('[data-about-item]');
    }
  }

  onTopNavKeydown(event: KeyboardEvent) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.focusTopNav(current, 1);
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.focusTopNav(current, -1);
      return;
    }

    if (event.key === 'Home') {
      event.preventDefault();
      this.focusFirst('[data-top-nav-item]');
      return;
    }

    if (event.key === 'End') {
      event.preventDefault();
      const items = this.getFocusable('[data-top-nav-item]');
      this.focusElement(items[items.length - 1]);
      return;
    }

    if (event.key === 'ArrowDown') {
      const menu = current.dataset['menuTrigger'] as 'products' | 'atendimento' | 'sobre' | undefined;
      if (!menu) {
        return;
      }

      event.preventDefault();
      this.openMenuByTrigger(menu);
      this.focusFirstMenuItem(menu);
    }
  }

  onProductsCategoryKeydown(event: KeyboardEvent, category: any) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.focusByDelta('[data-products-category]', current, 1);
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusByDelta('[data-products-category]', current, -1);
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.showSubcategory(true, category);
      queueMicrotask(() => this.focusFirst('[data-products-subcategory]'));
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.hideCategory();
      this.focusElement(this.getTriggerAnchor('products'));
    }
  }

  onProductsSubcategoryKeydown(event: KeyboardEvent, subCategory: any) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.focusByDelta('[data-products-subcategory]', current, 1);
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusByDelta('[data-products-subcategory]', current, -1);
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.showSubSubcategory(true, subCategory);
      queueMicrotask(() => this.focusFirst('[data-products-subsubcategory]'));
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.focusElement(
        this.elementRef.nativeElement.querySelector<HTMLElement>(
          `[data-products-category="${subCategory.parent_id}"]`
        )
      );
    }
  }

  onProductsSubSubcategoryKeydown(event: KeyboardEvent, subCategorieItem: any) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.focusByDelta('[data-products-subsubcategory]', current, 1);
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusByDelta('[data-products-subsubcategory]', current, -1);
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.focusElement(
        this.elementRef.nativeElement.querySelector<HTMLElement>(
          `[data-products-subcategory="${subCategorieItem.parent_id}"]`
        )
      );
    }
  }

  onAboutItemKeydown(event: KeyboardEvent, item: 'download' | 'reports' | 'about') {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusByDelta('[data-about-item]', current, event.key === 'ArrowDown' ? 1 : -1);
      return;
    }

    if (event.key === 'ArrowRight' && item === 'reports') {
      event.preventDefault();
      this.showReports(true);
      queueMicrotask(() => this.focusFirst('[data-about-report-item]'));
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.hideReport();
      this.focusElement(this.getTriggerAnchor('sobre'));
    }
  }

  onAboutReportKeydown(event: KeyboardEvent) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.focusByDelta('[data-about-report-item]', current, 1);
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusByDelta('[data-about-report-item]', current, -1);
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.focusFirst('[data-about-item]');
      this.hideReport();
    }
  }

  clearActiveMenu(menu: 'products' | 'atendimento' | 'sobre', event: Event) {
    const relatedTarget = (event as FocusEvent).relatedTarget as Node | null;
    const currentTarget = event.currentTarget as HTMLElement | null;

    if (relatedTarget && currentTarget?.contains(relatedTarget)) {
      return;
    }

    if (this.activeMenu === menu) {
      this.activeMenu = null;
    }

    if (menu === 'products' || menu === 'atendimento') {
      this.hideCategory();
    }

    if (menu === 'sobre') {
      this.hideReport();
    }
  }

  triggerAccessibilityModal() {
    window.dispatchEvent(new CustomEvent('open-accessibility-modal'));
  }

  openModalSearch(){
    document.body.classList.add('no-scroll');
    const dialogRef = this.matDialog.open( SearchComponent, {
      position: {
        top: '0',
        right:'0',
        bottom: '0'
      },
      minHeight: '100%',

    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }

  openModalMenu(){
    document.body.classList.add('no-scroll');
    const dialogRef = this.matDialog.open( MenuMobileComponent, {
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }
}
